import type { JwtPayload } from "../jwt/JwtPayload"
import {
	isApplicationManager,
	isGlobalManager,
	isLocalMarketManagerWithManagedMarketplaces,
} from "../roles/authFunctions"

export const hasMarketExportAccess = (claims: JwtPayload): boolean =>
	isGlobalManager(claims["ppn:groups"]) ||
	isLocalMarketManagerWithManagedMarketplaces(claims) ||
	isApplicationManager(claims["ppn:groups"])
